import axiosInstance from '@/axios/axiosInstance'
import { Tipology} from './types'

export const findAllTipologies = async (): Promise<Tipology[]> => {
  const response = await axiosInstance.get('/tipologia');
  return response.data;
};
